import Repository from '../repositories/RepositoryFactory'
import { ErrorHandler } from '../Helpers/ErrorHander'

export class CredentialService {
    constructor () {
        this.repository = Repository.get('credential')
        this.credential = {
            id: null,
            apiUrl: null,
            secretKeyHex: null,
        }
    }

    fromJson (data) {
        this.credential = {
            id: data.id,
            apiUrl: data.api_url,
            secretKeyHex: data.secret_key_hex,
        }
        return this.credential
    }

    async getCredential () {
        try {
            const response = await this.repository.get()
            if (response.status === 200) return this.fromJson(response.data.data)
            return new ErrorHandler(response.error, 'http', response.status)
        } catch (e) {
            return new ErrorHandler(e?.response?.data?.data?.message || e.message, 'http')
        }
    }

    async updateCredential () {
        try {
            const payload = {
                id: this.credential.id,
                api_url: this.credential.apiUrl,
                secret_key_hex: this.credential.secretKeyHex,
            }
            const response = await this.repository.put(payload)
            if (response.status === 200 || response.status === 201) return this.fromJson(response.data.data)
            return new ErrorHandler(response.error, 'http', response.status)
        } catch (e) {
            return new ErrorHandler(e?.response?.data?.data?.message || e.message, 'http')
        }
    }
}
